//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"CounterSpindleFace",1,"Face",0],[0,"MachineBaseJunctionName",1,0],[0,"MachineType",1,0],[0,"MachineZeroCsys",1,"CoordinateSystem",0],[0,"MainSpindleFace",1,"Face",0],[0,"MillPocketLocation",1,0],[0,"MillPocketNumber",1,0],[0,"SpindleFace",1,"Face",0],[0,"ToolMagazine",1,"NXObject",0],[0,"Turret",1,"NXObject",0],[0,"TurretPocketNumber",1,0],[0,"WorkpieceFace",1,"Face",0]],[],[]];
SPLM.CAM.ConvertFromMCDBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ConvertFromMCDBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ConvertFromMCDBuilder.MachineTypes = Object.freeze({
    "Mill" : "Mill", "Turn" : "Turn", "MillTurn" : "MillTurn"});

SPLM.CAM.ConvertFromMCDBuilder.PocketLocationTypes = Object.freeze({
    "Spindle" : "Spindle", "ToolMagazine" : "ToolMagazine"});

export default SPLM;